import { useEffect, useRef, useState } from "react";
import "./navbar.scss";
import gsap from "gsap";
import { MdOutlineClose } from "react-icons/md";
import logo from "../../assets/logo.png";
import { GiHamburgerMenu } from "react-icons/gi";
export const Navbar = ({ showNavbar, currentPage }) => {
  const menuAnimControllerRef = useRef(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const sectionHeaderRef = useRef(null);
  const menuListRef = useRef(null);
  const menuRef = useRef(null);
  useEffect(() => {
    const ctx = gsap.context(() => {
      menuAnimControllerRef.current = gsap
        .timeline({ paused: true })
        .to(menuRef.current, {
          height: "100vh",
          margin: "0",
          maxWidth: "100vw",
          width: "100vw",
          borderRadius: "0",
          duration: "0.7",
        })
        .to(
          sectionHeaderRef.current,
          {
            opacity: 0,
          },
          "<"
        )
        .to(menuListRef.current, {
          display: "flex",
          duration: "1",
        });
    });
    return () => ctx.revert();
  }, []);

  useEffect(() => {
    if (menuOpen) {
      menuAnimControllerRef.current.timeScale(1).play();
    } else {
      menuAnimControllerRef.current.timeScale(2).reverse();
    }
  }, [menuOpen]);

  const handleScroll = (id) => {
    setMenuOpen(false);
    const target = document.getElementById(id);
    if (target) {
      window.dispatchEvent(
        new CustomEvent("lenis-scroll-to", { detail: target })
      );
    }
  };
  return (
    <div
      className={`navbar_main ${showNavbar ? "show" : "hide"} prevent-select `}
    >
      <div className="navbar_container" ref={menuRef}>
        <div className="navbar_logo">
          <img src={logo} alt="highqc logo" />
        </div>
        {window.innerWidth < 1024 && (
          <div className="navbar_section_header" ref={sectionHeaderRef}>
            <h6>{currentPage.toUpperCase()}</h6>
          </div>
        )}
        {window.innerWidth >= 1024 && (
          <div className="navbar_section_header_lg">
            <div className={`navbar_meu_lg ${menuOpen ? "menu_open" : ""}`}>
              <h4
                onClick={() => handleScroll("home")}
                className={`menu_lg_list ${
                  currentPage === "home" ? "active_page" : ""
                }`}
              >
                HOME
              </h4>
              <h4
                onClick={() => handleScroll("about")}
                className={`menu_lg_list ${
                  currentPage === "about" ? "active_page" : ""
                }`}
              >
                ABOUT
              </h4>
              <h4
                onClick={() => handleScroll("services")}
                className={`menu_lg_list ${
                  currentPage === "services" ? "active_page" : ""
                }`}
              >
                SERVICES
              </h4>
              <h4
                onClick={() => {
                  handleScroll("partners");
                }}
                className={`menu_lg_list ${
                  currentPage === "partners" ? "active_page" : ""
                }`}
              >
                PATNERS
              </h4>
              <h4
                onClick={() => {
                  handleScroll("contact");
                }}
                className={`menu_lg_list ${
                  currentPage === "contact" ? "active_page" : ""
                }`}
              >
                CONTACT
              </h4>
            </div>
          </div>
        )}
        <div
          className="menu_list"
          ref={menuListRef}
          style={{ display: "none" }}
        >
          <ul>
            <li
              onClick={() => handleScroll("home")}
              style={{ fontWeight: currentPage == "HOME" ? "bold" : "normal" }}
            >
              HOME
            </li>
            <li
              onClick={() => handleScroll("about")}
              style={{ fontWeight: currentPage == "ABOUT" ? "bold" : "normal" }}
            >
              ABOUT
            </li>
            <li
              onClick={() => handleScroll("services")}
              style={{
                fontWeight: currentPage == "SERVICES" ? "bold" : "normal",
              }}
            >
              SERVICES
            </li>
            <li
              onClick={() => {
                handleScroll("partners");
              }}
              style={{
                fontWeight: currentPage == "PARTNERS" ? "bold" : "normal",
              }}
            >
              OUR PARTNERS
            </li>
            <li
              onClick={() => {
                handleScroll("contact");
              }}
              style={{
                fontWeight: currentPage == "CONTACT" ? "bold" : "normal",
              }}
            >
              CONTACT US
            </li>
          </ul>
        </div>
        {window.innerWidth < 1024 && (
          <div
            className="navbar_icon"
            onClick={() => {
              setMenuOpen(!menuOpen);
            }}
          >
            {!menuOpen ? <GiHamburgerMenu /> : <MdOutlineClose />}
          </div>
        )}
      </div>
    </div>
  );
};
